import { Typography } from '@mui/material';
import { MatchResultPlayerStatus } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC } from 'react';
import { useStyles } from './PlayerResultScore.styles';

interface PlayerResultScoreProps {
  status: MatchResultPlayerStatus;
  score: number;
}

export const PlayerResultScore: FC<PlayerResultScoreProps> = ({ status, score }) => {
  const { classes } = useStyles();

  if (!status) {
    return null;
  }

  return <Typography className={classNames(classes.root, classes[status])}>{score}</Typography>;
};
